import React, { useState } from 'react'
import { ListaCompanys } from './ListaCompanys'
import { AgendaAdmin } from '../AgendaAdmin/AgendaAdmin'

export const Companys = () => {

    const [selectAction, setSelectAction] = useState('LISTA_COMPANYS')
    const [selectedCompany, setSelectedCompany] = useState(null)

    const displayMenu = () => {
        switch (selectAction) {
            case 'LISTA_COMPANYS':
                return (
                    <ListaCompanys setSelectAction={setSelectAction} setSelectedCompany={setSelectedCompany} />
                )
            case 'VER_AGENDA':
                return (
                    <AgendaAdmin selectedCompany={selectedCompany} setSelectAction={setSelectAction} />
                )
            case 'VER_CLIENTES':
                return (
                    <div>
                        <button className="btn btn-link" onClick={() => setSelectAction('LISTA_COMPANYS')}>Volver</button>
                        <h3>Clientes de {selectedCompany?.nombres}</h3>
                    </div>
                )
            case 'VER_SERVICIOS':
                return (
                    <div>
                        <button className="btn btn-link" onClick={() => setSelectAction('LISTA_COMPANYS')}>Volver</button>
                        <h3>Servicios de {selectedCompany?.nombres}</h3>
                    </div>
                )
            default:
                return (
                    <></>
                )
        }
    }

    return (
        <>
            <div className='div-container-db-agenda' >
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12" >
                        <div className=''>
                            <h1 className='size-db-info-agenda-h1'>
                                Gestión de Compañías:
                            </h1>
                        </div>
                    </div>
                </div>
                <div className="">
                    <p className='p-label-form mt-3'>Administra la información de las compañías registradas y supervisa su tipo de gestión y negocio. </p>
                </div>
            </div>
            <div className='div-container-db-agenda mt-2'>
                {
                    displayMenu()
                }
            </div >
        </>

    )
}
